import { Descendant } from "slate";
import { createParagraphNode } from "../utils/nodeUtils";

interface SlateDebugViewProps {
  initialValue?: Descendant[];
}

const SlateDebugView: React.FC<SlateDebugViewProps> = ({
  initialValue = [createParagraphNode()],
}) => {
  return (
    <div className="p-4 bg-gray-100 rounded-md shadow-md dark:bg-gray-800">
      <strong>Editor Content (JSON):</strong>
      <pre>{JSON.stringify(initialValue, null, 2)}</pre>
    </div>
  );
};

export default SlateDebugView;
